<template>
    <v-layout :full-height="!loaded" column>
        <slot v-if="loaded" />
        <v-layout v-else class="align-center justify-center">
            <v-progress-circular indeterminate size="64" color="primary" />
        </v-layout>
    </v-layout>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class LoadingPageLayout extends Vue {
        @Prop({required: false, type: Boolean}) loaded
    }

    export default LoadingPageLayout
</script>
